"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getESRICopyRight = void 0;
const olProj = __importStar(require("ol/proj"));
const olExtent = __importStar(require("ol/extent"));
const icos_cp_backend_1 = require("icos-cp-backend");
// https://developers.arcgis.com/terms/attribution/
class Copyright {
    constructor(attributionESRI, projection, htmlElementId, minWidth) {
        this.attributionESRI = attributionESRI;
        this.projection = projection;
        this.minWidth = minWidth;
        const attributionElement = document.getElementById(htmlElementId);
        if (attributionElement === null) {
            console.error(`Could not find html element with id = ${htmlElementId} in DOM. Attribution is disabled.`);
            this.isInitialized = false;
            this.attributionElement = document.createElement('i');
        }
        else {
            this.isInitialized = true;
            this.attributionElement = attributionElement;
        }
    }
    getAttribution(bbox, serviceName, zoom = 1) {
        const projectedExtent = this.projection.getCode() === 'EPSG:4326'
            ? bbox
            : olProj.transformExtent(bbox, this.projection, olProj.get('EPSG:4326'));
        const filteredAttributions = this.attributionESRI[serviceName].contributors.filter((contributor) => {
            return contributor.coverageAreas.some(coverage => {
                const coverageExtent = [coverage.bbox[1], coverage.bbox[0], coverage.bbox[3], coverage.bbox[3]];
                return zoom >= coverage.zoomMin && zoom <= coverage.zoomMax && olExtent.intersects(projectedExtent, coverageExtent);
            });
        });
        return filteredAttributions
            .sort((attr) => attr.coverageAreas[0].score)
            .map((attr) => attr.attribution);
    }
    updateAttribution(view, layers) {
        const width = document.getElementsByTagName('body')[0].getBoundingClientRect().width;
        if (width < this.minWidth)
            return;
        const currentBasemap = layers.find(layer => layer.getVisible() && layer.get('layerType') === 'baseMap');
        const isEsri = currentBasemap?.get('isEsri');
        let attributionText = '';
        const esriServiceName = currentBasemap
            ? currentBasemap.get('esriServiceName')
            : undefined;
        if (esriServiceName) {
            const attributions = this.getAttribution(view.calculateExtent(), esriServiceName, view.getZoom());
            attributionText = attributions.join(', ');
        }
        else if (currentBasemap) {
            const source = currentBasemap.getSource();
            if (source === null || source.getAttributions() === null)
                return;
            let getAttributions = source && source.getAttributions();
            if (getAttributions) {
                const attributions = getAttributions(undefined);
                attributionText = Array.isArray(attributions) ? attributions.join(', ') : attributions;
            }
        }
        const poweredByESRI = isEsri
            ? attributionText.length > 0 ? 'Powered by ESRI - ' : 'Powered by ESRI'
            : '';
        this.attributionElement.innerHTML = poweredByESRI + attributionText;
    }
}
exports.default = Copyright;
const getESRICopyRight = (services) => {
    if (services.length === 0)
        return Promise.resolve({});
    const promises = services.map(service => (0, icos_cp_backend_1.getJson)('https://static.arcgis.com/attribution/' + service + '?f=json'));
    return Promise.all(promises).then(results => {
        return results.reduce((acc, doc, idx) => {
            acc[services[idx]] = doc;
            return acc;
        }, {});
    });
};
exports.getESRICopyRight = getESRICopyRight;
